import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import enOrg from './locales/en/organizations.json'
import viOrg from './locales/vi/organizations.json'
import enProfile from './locales/en/profile.json'
import viProfile from './locales/vi/profile.json'
import enAdmin from './locales/en/admin.json'
import viAdmin from './locales/vi/admin.json'
import enPermissionKeys from './locales/en/permissionKeys.json'
import viPermissionKeys from './locales/vi/permissionKeys.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          ...enOrg,
          ...enPermissionKeys,
          profile: enProfile,
          admin: enAdmin,
        },
      },
      vi: {
        translation: {
          ...viOrg,
          ...viPermissionKeys,
          profile: viProfile,
          admin: viAdmin,
        },
      },
    },
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n